import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const MoreActionsButton = ({ id, onClickMoreAction }: { id?: string; onClickMoreAction?: (event: React.MouseEvent<HTMLButtonElement>) => void }) => (
  <button
    id={id}
    aria-label='More Action'
    type='button'
    className='w-[28px] xl:w-32 h-[28px] xl:h-32 flex items-center justify-center border-1 xl:border-2 border-neutral-20 rounded-4'
    onClick={onClickMoreAction}
  >
    <MoreHorizIcon />
  </button>
);
